module.exports = __webpack_public_path__ + "components/weather-icon/static/nightcloud@2-91e5a860cb7b0e2793566f1ccb9f21b5.png";